export const isEmail = (text) => { // input "" || "asd" => (return false) ; input asd@gmail.com (return true)
  const emailValidationRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return emailValidationRegex.test(text);
};